import DashboardContainer from '@/containers/interaction/DashboardContainer';
import InteractionSearchContainer from '@/containers/interaction/InteractionSearchContainer';

export default [
  {
    path: '/interactions',
    name: 'Interaction',
    meta: { requiresAuth: true, action: 'view', subject: 'interactions' },
    component: DashboardContainer,
  },
  {
    path: '/interactions/search',
    name: 'InteractionSearch',
    meta: { requiresAuth: true, action: 'view', subject: 'interactions' },
    component: InteractionSearchContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/interaction.js